import { render } from "./Services1Section.vue?vue&type=template&id=5953b6fa&scoped=true"
import script from "./Services1Section.vue?vue&type=script&lang=js"
export * from "./Services1Section.vue?vue&type=script&lang=js"

import "./Services1Section.vue?vue&type=style&index=0&id=5953b6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5953b6fa"]])

export default __exports__